module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"showAzureSubscriptions.title":"Azure App Credential Subscriptions","showAzureSubscriptions.subscriptions":"Subscriptions","showAzureSubscriptions.noSubscriptions":"No Subscriptions visible."}}')
  delete Component.options._Ctor
}
